export const CATEGORIES = [
  { key: 'upbit', label: '업비트', labelKey: 'exchange.upbit' },
  { key: 'bithumb', label: '빗썸', labelKey: 'exchange.bithumb' },
  { key: 'coinone', label: '코인원', labelKey: 'exchange.coinone' },
  { key: 'digitalx', label: '디지털엑스', labelKey: 'exchange.digitalx' },
  { key: 'gopax', label: '고팍스', labelKey: 'exchange.gopax' }
]
export const TABS = [
  { key: 'volume', label: '거래대금', labelKey: 'ranking.tabs.volume' },
  { key: 'gainer', label: '상승', labelKey: 'ranking.tabs.gainer' },
  { key: 'loser', label: '하락', labelKey: 'ranking.tabs.loser' },
  { key: 'marketCap', label: '시가총액', labelKey: 'ranking.tabs.marketCap' }
]

const DEFAULT_EXCHANGE_ORDER = ['upbit', 'bithumb', 'coinone', 'digitalx', 'gopax']

const EXCHANGE_ORDER_BY_TARGET = {
  ASP: DEFAULT_EXCHANGE_ORDER,
  MSTOCK: ['digitalx', 'bithumb', 'coinone', 'gopax'],
  jb: ['upbit', 'gopax', 'bithumb', 'coinone', 'digitalx']
}

export const getExchangeOrder = (appTarget) => {
  return EXCHANGE_ORDER_BY_TARGET[appTarget] ?? DEFAULT_EXCHANGE_ORDER
}

const CATEGORY_BY_KEY = Object.fromEntries(CATEGORIES.map((category) => [category.key, category]))

export const getOrderedCategories = (appTarget) => {
  return getExchangeOrder(appTarget)
    .map((key) => CATEGORY_BY_KEY[key])
    .filter(Boolean)
}

const RANKING_TAB_ORDER_BY_TARGET = {
  jb: ['marketCap', 'gainer', 'loser', 'volume']
}

const RANKING_TAB_BY_KEY = Object.fromEntries(TABS.map((tab) => [tab.key, tab]))

export const getOrderedRankingTabs = (appTarget) => {
  const order = RANKING_TAB_ORDER_BY_TARGET[appTarget]

  if (!order) {
    return TABS
  }

  return order.map((key) => RANKING_TAB_BY_KEY[key]).filter(Boolean)
}
